export const THEME_BLUE_PURPLE = 'theme-blue-purple';
export const THEME_ORANGE_RED = 'theme-orange-red';
